import { Map } from 'immutable';

import Api from '../api';

import Role from './model';
import { addAction, addMultipleAction, updateAction, removeAction } from './actions';

export default class RolesApi {
  static fetchAllRaw() {
    return Api.get('api/roles');
  }

  static fetchAll() {
    return RolesApi.fetchAllRaw().map((roles) =>
      addMultipleAction(Map(roles.map((role) => [role.id, new Role(role)])))
    );
  }

  static fetch(id) {
    return Api.get(`api/roles/${id}`).map((role) => addAction(new Role(role)));
  }

  static create(data) {
    return Api.post('api/roles', data).map((role) => addAction(new Role(role)));
  }

  static update(id, data) {
    return Api.patch(`api/roles/${id}`, data).map((role) => updateAction(new Role(role)));
  }

  static delete(id) {
    return Api.delete(`api/roles/${id}`).map(() => removeAction(id));
  }
}
